import { EditOutlined, CopyOutlined, DeleteOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import type { WidgetEntry } from "../Contexts/dashboardState";

/** The per-widget grid context menu (edit / duplicate / delete). */
export function buildWidgetMenuItems(
  widget: WidgetEntry,
  opts: {
    disabled: boolean;
    onEdit: (widget: WidgetEntry) => void;
    onDuplicate: (widgetId: string) => void;
    onDelete: (widget: WidgetEntry) => void;
  },
): MenuProps["items"] {
  const { disabled, onEdit, onDuplicate, onDelete } = opts;
  return [
    { key: "edit", icon: <EditOutlined />, label: "Edit", disabled, onClick: () => onEdit(widget) },
    { key: "duplicate", icon: <CopyOutlined />, label: "Duplicate", disabled, onClick: () => onDuplicate(widget.id) },
    { type: "divider" },
    { key: "delete", icon: <DeleteOutlined />, label: "Delete", danger: true, disabled, onClick: () => onDelete(widget) },
  ];
}
